
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4 6a1 1 0 110 2 1 1 0 010-2zm0 5a1 1 0 110 2 1 1 0 010-2zm0 5a1 1 0 110 2 1 1 0 010-2zm16.064-5c.515 0 .936.421.936.936v.128a.938.938 0 01-.936.936H7.936A.938.938 0 017 12.064v-.128c0-.515.42-.936.936-.936h12.128zm0 5c.515 0 .936.421.936.936v.128a.938.938 0 01-.936.936H7.936A.938.938 0 017 17.064v-.128c0-.515.42-.936.936-.936h12.128zm0-10c.515 0 .936.421.936.936v.128a.938.938 0 01-.936.936H7.936A.938.938 0 017 7.064v-.128C7 6.421 7.42 6 7.936 6h12.128z"}})])
          )
        }
      }
    